import { SVGProps } from "react";

export const EthernetIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#000"
        d="M2.25 4c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v10.5c0 .69-.56 1.25-1.25 1.25h-1.25v.75c0 .69-.56 1.25-1.25 1.25h-1.25v1.75c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25v-1.75H6c-.69 0-1.25-.56-1.25-1.25v-.75H3.5c-.69 0-1.25-.56-1.25-1.25zM4 3.75a.25.25 0 0 0-.25.25v10.25h2.5v2h2.5v3h6.5v-3h2.5v-2h2.5V4a.25.25 0 0 0-.25-.25zM6.75 6.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
        clipRule="evenodd"
        fillOpacity=".9"
        fillRule="evenodd"
      />
    </svg>
  );
};
